import Cookies from 'js-cookie'
const DEFAULT_EXPIRES = 365 // 1 year (365 days)

// default settings for cookies
// js-cookie v3 removed the mutable `Cookies.defaults`; use withAttributes() instead
export default Cookies.withAttributes({ expires: DEFAULT_EXPIRES, path: '/' })
